import type { FeatureConfig } from '@/core/registry'
import caseStudiesRoutes from './routes'
import caseStudiesLocales from './locales'
import { caseStudiesHandlers } from './mocks'
import { CASE_STUDIES_PERMISSIONS } from './constants/permissions.constants'

const config: FeatureConfig = {
  routes: caseStudiesRoutes,
  locales: { ns: 'caseStudies', resources: caseStudiesLocales },
  handlers: caseStudiesHandlers,
  permissions: CASE_STUDIES_PERMISSIONS,
}

export default config
